import React from 'react';
import {MainHeader, PageWrapperLayout, Snackbar} from 'presentation/components';
import {AddressForm} from 'presentation/components/ChangeData/Address/AddressForm';
import {translations} from 'presentation/translations-new';
import {CustomBox} from './styles';
import {Stack, Typography} from '@mui/material';
import {useEditFavoritePlace} from './hooks/useEditFavoritePlace';

const {editAddress, saveAddress, editFavoritePlace} =
	translations['pt-br'].privateFlow.bookingFlow.location;
const {title} = translations['pt-br'].privateFlow.profile.changeData.address;

export function HealthGuideFavoritePlacesEdit() {
	const {
		isMobOrTab,
		handleBack,
		onSubmit,
		openEditFavoritePlaceSuccess,
		handleCloseFavoritePlaceSuccess,
		openEditFavoritePlaceError,
		handleCloseEditFavoritePlaceError,
		isPatchingFavoritePlace,
		item,
	} = useEditFavoritePlace();

	if (!item) {
		return (
			<PageWrapperLayout title={title}>
				<MainHeader title={title} handleBack={handleBack} hideProfileMenu />
				<Stack
					paddingX={isMobOrTab ? undefined : 5}
					paddingY={isMobOrTab ? undefined : 3}
					gap={2}>
					<Typography variant="body1">{title}</Typography>
				</Stack>
			</PageWrapperLayout>
		);
	}

	return (
		<PageWrapperLayout title={editAddress}>
			<MainHeader title={editAddress} handleBack={handleBack} hideProfileMenu />
			<Stack
				paddingX={isMobOrTab ? undefined : 5}
				paddingY={isMobOrTab ? undefined : 3}
				gap={2}>
				<CustomBox $isMobOrTab={isMobOrTab}>
					<Typography variant="button" color="text.secondary">
						{title}
					</Typography>
					<AddressForm
						onCancel={handleBack}
						onSave={onSubmit}
						address={item}
						withoutAlertInfo
						withoutCancelButton
						responsiveButtons
						hasFavoriteAddressField
						favoriteAddressDescription={item?.favoriteAddress ?? ''}
						saveLabel={saveAddress}
						loading={isPatchingFavoritePlace}
					/>
				</CustomBox>
			</Stack>
			<Snackbar
				open={openEditFavoritePlaceError}
				onClose={handleCloseEditFavoritePlaceError}
				message={editFavoritePlace.error}
			/>
			<Snackbar
				open={openEditFavoritePlaceSuccess}
				onClose={handleCloseFavoritePlaceSuccess}
				message={editFavoritePlace.success}
				autoHideDuration={1500}
			/>
		</PageWrapperLayout>
	);
}
